module.exports = __webpack_public_path__ + "img/ic-contact-line.7fbbdf83.png";